import React from "react";
import { Link } from "react-router-dom";
const linkRows = [
  ["JOIN SELECTEZI", "CREATE YOUR SHOWCASE", "EXPLORE BUSINESSES", "FIND WHAT YOU NEED"],
  ["SHOW WHAT YOU HAVE", "DISCOVER OPPORTUNITIES", "START YOUR BUSINESS JOURNEY"],
  ["PROMOTE YOUR BUSINESS", "EXPLORE PREMIUM", "PARTNER WITH SELECTEZI", "INVEST IN SELECTEZI"],
];

export default function Footer() {
  return (
    <>
      <footer className="site-footer-home">
        <div className="container">
          <h2>SELECTEZI</h2>
          <p className="footer-tagline">
            FIND WHAT YOU NEED TO BUY &bull; SHOW WHAT YOU WANT TO SELL &bull; DISCOVER
            WHAT YOU CAN BECOME TOMORROW
          </p>

          <p className="footer-body">
            EVERY BUSINESS IS A RESOURCE EVERY RESOURCE CAN CREATE AN
            OPPORTUNITY EVERY OPPORTUNITY CAN BECOME A BUSINESS
          </p>
          <p className="footer-tagline" style={{ marginTop: "-0.5rem" }}>
            SELECTEZI, WHERE PEOPLE DISCOVER WHAT THEY CAN BECOME TOMORROW
          </p>

          <div className="footer-pill">
            FROM CONSUMER &rarr; OPPORTUNITY &rarr; BUSINESS &rarr; GROWTH
          </div>

        <ul className="footer-cta-title">
  <li>CONNECT</li>
  <li>DISCOVER</li>
  <li>CREATE OPPORTUNITIES</li>
  <li>GROW TOGETHER</li>
</ul>

          {linkRows.map((row, i) => (
            <div className="footer-links pb-4" key={i}>
              {row.map((link) => (
                <a
                  href="#"
                  key={link}
                  className={`footer-link-btn${
                    link === "JOIN SELECTEZI" ? " primary" : ""
                  }${link === "INVEST IN SELECTEZI" ? " primary" : ""}`}
                >
                  {link}
                </a>
              ))}
            </div>
          ))}

         
        </div>
      </footer>

      
   <footer className="selectezi-footer p-3">
  <div className=" d-flex align-items-center justify-content-between flex-wrap gap-2">
    <span>
      &copy; 2025 SELECTEZI Inc. All rights reserved.
    </span>

    <div className="d-flex align-items-center gap-3">
      <Link to="/general-terms">General Terms</Link>
      <Link to="/privacy-policy">Privacy Policy</Link>
    </div>
  </div>
</footer>
      
    </>
  );
}
